import { useEffect, useState } from "react";
import { Modal } from "flowbite-react";
import { useToastContext } from "../../../common/components/ui/toast/toast.context";
import { emptyEmployee, IEmployee } from "../../../types/employee.type";
import {
  createEmployee,
  getEmployeeById,
  updateEmployee,
} from "../../../common/services/employee.api";
import Loading from "../../../common/components/ui/loading/Loading";
import FormEditEmployeeData from "../form/FormEditEmployee";

type Props = {
  employeeId: null | string;
  onClose: () => void;
};

export default function ModalEditEmployee(props: Props) {
  const [employeeId, setEmployeeId] = useState<string | null>(null);
  const { showToast } = useToastContext();
  const [employeeData, setEmployeeData] = useState<IEmployee | null>(null);
  const [formRequestErrors] = useState([]);

  const notifySuccess = (text) => showToast({ text, type: "success" });
  const notifyError = (text) => showToast({ text, type: "error" });

  const handleCloseModal = () => {
    props.onClose();
  };

  useEffect(() => {
    props.employeeId !== employeeId && setEmployeeId(props.employeeId);
  }, [props.employeeId, employeeId]);

  useEffect(() => {
    if (!employeeId) {
      setEmployeeData(emptyEmployee);
      return;
    }

    async function loadEmployees() {
      if (!employeeId) return;
      const { data, ok } = await getEmployeeById(employeeId);
      if (ok) {
        setEmployeeData(data as IEmployee);
      }
    }

    loadEmployees();
  }, [employeeId]);

  async function saveEmployee(dataToSave: IEmployee) {
    try {
      const response = employeeId
        ? await updateEmployee(employeeId as string, dataToSave)
        : await createEmployee(dataToSave);

      const { ok, data, errors } = response;

      if (ok && data) {
        setEmployeeData(data as IEmployee);

        notifySuccess(
          `Colobarador "${(data as IEmployee).name}" ${
            employeeId ? "atualizado" : "criado"
          }!`
        );
        handleCloseModal();
        return {
          ok,
          data: data as IEmployee,
          errors: errors as [{ message: string; path: string[] }],
        };
      }

      if (!ok) {
        notifyError(response.message as string);
      }

      return {
        ok,
        data: data as IEmployee,
        errors: errors as [{ message: string; path: string[] }],
      };
    } catch (err) {
      notifyError("Erro ao tentar salvar cliente, tente novamente");
      return {
        ok: false,
        data: dataToSave,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }],
      };
    }
  }

  return (
    <Modal
      size={"5xl"}
      className="relative px-2 sm:px-0"
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className="text-black">
        <div className="flex min-w-0 items-center justify-start gap-3 text-black">
          <span>
            {!employeeData?._id
              ? `Criando Colobarador`
              : `Editando Colobarador`}
          </span>
        </div>
      </Modal.Header>
      <Modal.Body
        className="relative flex w-full flex-col overflow-y-auto px-3 pb-4 pt-2 text-black sm:px-5"
        style={{
          maxHeight: "calc(100vh - 9rem)",
        }}
      >
        {employeeData ? (
          <FormEditEmployeeData
            data={employeeData}
            onSubmit={saveEmployee}
            formRequestErrors={formRequestErrors}
          />
        ) : (
          <Loading />
        )}
      </Modal.Body>
    </Modal>
  );
}
